import * as index from '@syncfusion/ej2-lineargauge';
index.LinearGauge.Inject( index.GaugeTooltip,index.Annotations);
export * from '@syncfusion/ej2-lineargauge';
